var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayerPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentcolor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 22.857C2 23.488 2.512 24 3.143 24h4.714C8.488 24 9 23.488 9 22.857V1.143C9 .512 8.488 0 7.857 0H3.143C2.512 0 2 .512 2 1.143zm13 0c0 .631.512 1.143 1.143 1.143h4.714c.631 0 1.143-.512 1.143-1.143V1.143C22 .512 21.488 0 20.857 0h-4.714C15.512 0 15 .512 15 1.143z"
})));
export default SvgPlayerPause;